var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable */
/* tslint:disable */
import * as React from 'react';
var Wc = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M9,9 C10.1045695,9 11,9.8954305 11,11 L11,16 L10,16 L10,21 L5,21 L5,16 L4,16 L4,11 C4,9.8954305 4.8954305,9 6,9 L9,9 Z M17.2192236,9 C17.6780912,9 18.0780743,9.31229737 18.1893661,9.75746437 L20,17 L17,17 L17,21 L14,21 L14,17 L11,17 L12.8106339,9.75746437 C12.9219257,9.31229737 13.3219088,9 13.7807764,9 L17.2192236,9 Z M9,10 L6,10 C5.48716416,10 5.06449284,10.3860402 5.00672773,10.8833789 L5,11 L5,15 L6,15 L6,20 L9,20 L9,15 L10,15 L10,11 C10,10.4871642 9.61395981,10.0644928 9.11662113,10.0067277 L9,10 Z M17.2192236,10 L13.7807764,10 L12.28,16 L15,16 L15,20 L16,20 L16,16 L18.719,16 L17.2192236,10 Z M7.5,4 C8.88071187,4 10,5.11928813 10,6.5 C10,7.88071187 8.88071187,9 7.5,9 C6.11928813,9 5,7.88071187 5,6.5 C5,5.11928813 6.11928813,4 7.5,4 Z M15.5,4 C16.8807119,4 18,5.11928813 18,6.5 C18,7.88071187 16.8807119,9 15.5,9 C14.1192881,9 13,7.88071187 13,6.5 C13,5.11928813 14.1192881,4 15.5,4 Z M7.5,5 C6.67157288,5 6,5.67157288 6,6.5 C6,7.32842712 6.67157288,8 7.5,8 C8.32842712,8 9,7.32842712 9,6.5 C9,5.67157288 8.32842712,5 7.5,5 Z M15.5,5 C14.6715729,5 14,5.67157288 14,6.5 C14,7.32842712 14.6715729,8 15.5,8 C16.3284271,8 17,7.32842712 17,6.5 C17,5.67157288 16.3284271,5 15.5,5 Z" })));
};
Wc.displayName = 'Wc';
export default Wc;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=Wc.js.map